import React from 'react';
import { AccordionContent, AccordionHeader, AccordionItem, AccordionTitle, Heading } from 'telia-front-react';

interface ISectionProps {
  id: string;
  title: string;
  subTitle?: React.ReactNode;
  icon: string;
  children: React.ReactNode;
}

const LoginMethodsAccordionItem = (props: ISectionProps): React.JSX.Element => {
  return (
    <AccordionItem id={props.id} icon={props.icon} background="neutral-bg-level-2">
      <AccordionHeader>
        <AccordionTitle>
          <Heading level={2} className="h4 text-bold">
            {props.title}
          </Heading>
          <p className="text-weight-normal text-tiny text-color-normal">{props.subTitle}</p>
        </AccordionTitle>
      </AccordionHeader>
      <AccordionContent>{props.children}</AccordionContent>
    </AccordionItem>
  );
};

export default LoginMethodsAccordionItem;
